var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14391 12.4003C1.04944 12.2771 1 12.1394 1 11.9996C1 11.8597 1.04944 11.722 1.14391 11.5989C3.45642 8.59971 7.72821 6 12 6C16.2718 6 20.5436 8.59971 22.8561 11.5997C22.9506 11.7229 23 11.8606 23 12.0004C23 12.1403 22.9506 12.278 22.8561 12.4011C20.5436 15.4003 16.2718 18 12 18C7.72821 18 3.45642 15.4003 1.14391 12.4003V12.4003Z",
    stroke: "#329DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5012 10.118C14.8573 10.3542 15.1422 10.638 15.3392 10.9528C15.5361 11.2675 15.6411 11.6067 15.6479 11.9504C15.6547 12.294 15.5632 12.6352 15.3788 12.9536C15.1944 13.2721 14.9209 13.5614 14.5743 13.8044C14.2278 14.0474 13.8152 14.2393 13.3611 14.3686C12.907 14.4979 12.4206 14.5621 11.9305 14.5573C11.4405 14.5525 10.9567 14.4789 10.508 14.3408C10.0592 14.2027 9.65441 14.0028 9.31762 13.7531C8.66992 13.2657 8.31731 12.621 8.33407 11.9548C8.35083 11.2886 8.73565 10.653 9.40747 10.1819C10.0793 9.71074 10.9856 9.44087 11.9356 9.42911C12.8855 9.41736 13.8049 9.66464 14.5 10.1189",
    stroke: "#329DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5baed023d198670376efb559dbeb2966.svg";
export { ForwardRef as ReactComponent };